<template>
  <div class="colorselector">
    <div class="controls">
      <div class="color-selector">
        <div
          :id="'sat_' + uid"
          class="colorselector-sat-light"
          :style="'background-color:rgb(' + r + ',' + g + ',' + b + ')'"
          @mousedown="satDown"
        >
          <div
            class="marker"
            :style="'top:' + light_mod + '%; left:' + sat_mod + '%;'"
          />
        </div>
        <div class="padder" />
        <div :id="'hue_' + uid" class="colorselector-rgb" @mousedown="hueDown">
          <div class="marker-height" :style="'left:' + hue + '%'" />
        </div>
        <div class="padder" />
        <div
          :id="'alpha_' + uid"
          class="colorselector-a"
          @mousedown="alphaDown"
        >
          <div class="marker-height" :style="'left:' + a * 100 + '%'" />
          <div
            :style="
              'width:100%; height: 100%; background-image: linear-gradient(to right, transparent, ' +
              noAlphaHex +
              ')'
            "
          />
        </div>
        <div class="padder" />
      </div>
      <va-input
        type="text"
        maxlength="7"
        class="hex-input"
        :data="hexData"
        :field-model="{ fieldName: 'color', label: 'HEX' }"
        @updated-data="hexInput"
      />
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
export default {
  props: {
    defaultValue: {
      type: String,
      default: null,
    },
  },
  emits: ['colorchange'],
  data() {
    return {
      r: 255,
      g: 0,
      b: 0,
      a: 1,
      hue: 0,
      light_mod: 0,
      sat_mod: 100,
      activeElem: '',
      trackMouse: '',
      hexInputDelay: '',
      uid: uuidv4(),
    };
  },
  computed: {
    hexData() {
      return { color: this.selectedHex };
    },
    selectedRGBA() {
      var data = this.hsvToRgb(
        this.hue / 100,
        this.sat_mod / 100,
        1 - this.light_mod / 100,
      );
      var rgba =
        'rgba(' + data.r + ',' + data.g + ',' + data.b + ',' + this.a + ')';
      this.$emit('colorchange', rgba);
      return rgba;
    },
    selectedHex: function () {
      return this.rgbaToHex(this.selectedRGBA);
    },
    noAlphaHex: function () {
      return this.selectedHex.substring(0, 7);
    },
  },
  mounted: function () {
    this.$nextTick(() => {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      var that = this;
      document.addEventListener('mouseup', function () {
        that.activeElem = '';
        if (that.trackMouse)
          document.removeEventListener('mousemove', that.trackMouse);
      });
      if (this.defaultValue)
        this.hexInput(this.rgbaToHex(this.defaultValue), true);
    });
  },
  methods: {
    hexInput(e, instant) {
      let delay = instant ? 0 : 600;
      if (this.hexInputDelay) clearTimeout(this.hexInputDelay);
      this.hexInputDelay = setTimeout(() => {
        if (e != null && e.length > 1) {
          let rgb = this.hexToRgba(e);
          let hsv = this.rgbToHsv(rgb[0], rgb[1], rgb[2]);
          this.hue = hsv.h * 100;
          this.sat_mod = hsv.s * 100;
          this.light_mod = 100 - hsv.v * 100;
          this.r = rgb[0];
          this.g = rgb[1];
          this.b = rgb[2];
        }
        this.setHue();
      }, delay);
    },
    rgbToHsv(r, g, b) {
      var max = Math.max(r, g, b),
        min = Math.min(r, g, b),
        d = max - min,
        h,
        s = max === 0 ? 0 : d / max,
        v = max / 255;

      switch (max) {
        case min:
          h = 0;
          break;
        case r:
          h = g - b + d * (g < b ? 6 : 0);
          h /= 6 * d;
          break;
        case g:
          h = b - r + d * 2;
          h /= 6 * d;
          break;
        case b:
          h = r - g + d * 4;
          h /= 6 * d;
          break;
      }

      return { h: h, s: s, v: v };
    },
    hsvToRgb(h, s, v) {
      var r, g, b, i, f, p, q, t;
      i = Math.floor(h * 6);
      f = h * 6 - i;
      p = v * (1 - s);
      q = v * (1 - f * s);
      t = v * (1 - (1 - f) * s);
      switch (i % 6) {
        case 0:
          r = v;
          g = t;
          b = p;
          break;
        case 1:
          r = q;
          g = v;
          b = p;
          break;
        case 2:
          r = p;
          g = v;
          b = t;
          break;
        case 3:
          r = p;
          g = q;
          b = v;
          break;
        case 4:
          r = t;
          g = p;
          b = v;
          break;
        case 5:
          r = v;
          g = p;
          b = q;
          break;
      }
      return {
        r: Math.round(r * 255),
        g: Math.round(g * 255),
        b: Math.round(b * 255),
      };
    },

    hslToRgb(h, s, l) {
      var r, g, b;

      l = l - 0.5 * (s * l);

      if (s == 0) {
        r = g = b = l; // achromatic
      } else {
        var hue2rgb = function hue2rgb(p, q, t) {
          if (t < 0) t += 1;
          if (t > 1) t -= 1;
          if (t < 1 / 6) return p + (q - p) * 6 * t;
          if (t < 1 / 2) return q;
          if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
          return p;
        };

        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
      }
      return [
        Math.max(0, Math.min(Math.round(r * 255), 255)),
        Math.max(0, Math.min(Math.round(g * 255), 255)),
        Math.max(0, Math.min(Math.round(b * 255), 255)),
      ];
    },
    rgbaToHex(rgb) {
      rgb = rgb.match(
        /^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?([0-9]\.[0-9]{1,2}|[0-9])[\s+]?/i,
      );
      return rgb && rgb.length === 4
        ? '#' +
            ('0' + parseInt(rgb[1], 10).toString(16)).slice(-2) +
            ('0' + parseInt(rgb[2], 10).toString(16)).slice(-2) +
            ('0' + parseInt(rgb[3], 10).toString(16)).slice(-2)
        : rgb && rgb.length === 5
          ? '#' +
            ('0' + parseInt(rgb[1], 10).toString(16)).slice(-2) +
            ('0' + parseInt(rgb[2], 10).toString(16)).slice(-2) +
            ('0' + parseInt(rgb[3], 10).toString(16)).slice(-2) +
            ('0' + parseInt(rgb[4] * 255, 10).toString(16)).slice(-2)
          : '';
    },
    hexToRgba(hex) {
      hex = hex.replace('#', '');
      if (hex.length == 3) {
        hex = String(hex[0]) + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }
      return [
        parseInt(hex.substring(0, 2), 16),
        parseInt(hex.substring(2, 4), 16),
        parseInt(hex.substring(4, 6), 16),
      ];
    },
    hueDown(e) {
      this.activeElem = e.target;
      this.trackMouse = this.hueSelection;
      this.hueSelection(e);
      document.addEventListener('mousemove', this.hueSelection);
    },
    satDown(e) {
      this.activeElem = e.target;
      this.trackMouse = this.satlightSelection;
      this.satlightSelection(e);
      document.addEventListener('mousemove', this.satlightSelection);
    },
    alphaDown(e) {
      this.activeElem = e.target;
      this.trackMouse = this.alphaSelection;
      this.alphaSelection(e);
      document.addEventListener('mousemove', this.alphaSelection);
    },
    alphaSelection(e) {
      let elemPos = this.activeElem.getBoundingClientRect();
      let offsetX = e.clientX - elemPos.left;
      let alpha =
        offsetX > this.activeElem.clientWidth
          ? 100
          : offsetX < 0
            ? 0
            : offsetX / (this.activeElem.clientWidth / 100);
      this.a = (alpha / 100).toFixed(2);
    },
    hueSelection(e) {
      let elemPos = this.activeElem.getBoundingClientRect();
      let offsetX = e.clientX - elemPos.left;
      let value =
        offsetX > this.activeElem.clientWidth
          ? 100
          : offsetX < 0
            ? 0
            : offsetX / (this.activeElem.clientWidth / 100);
      this.hue = value;
      this.setHue();
    },
    satlightSelection(e) {
      let elemPos = this.activeElem.getBoundingClientRect();
      let offsetY = e.clientY - elemPos.top;
      let offsetX = e.clientX - elemPos.left;
      this.light_mod =
        offsetY > this.activeElem.clientHeight
          ? 100
          : offsetY < 0
            ? 0
            : offsetY / (this.activeElem.clientHeight / 100);
      this.sat_mod =
        offsetX > this.activeElem.clientWidth
          ? 100
          : offsetX < 0
            ? 0
            : offsetX / (this.activeElem.clientWidth / 100);
    },
    setHue() {
      let value = this.hue;
      let r = 0;
      let g = 0;
      let b = 0;
      if (value <= 16.6) {
        let cval = value / 16.6;
        r = 255;
        g = 255 * cval;
      } else if (value <= 33.2) {
        let cval = 1 - (value - 16.6) / 16.6;
        r = 255 * cval;
        g = 255;
      } else if (value <= 49.8) {
        let cval = (value - 33.2) / 16.6;
        g = 255;
        b = 255 * cval;
      } else if (value <= 66.4) {
        let cval = 1 - (value - 49.8) / 16.6;
        g = 255 * cval;
        b = 255;
      } else if (value <= 83) {
        let cval = (value - 66.4) / 16.6;
        r = 255 * cval;
        b = 255;
      } else if (value <= 100) {
        let cval = 1 - (value - 83) / 17;
        r = 255;
        b = 255 * cval;
      }
      this.r = Math.floor(r);
      this.g = Math.floor(g);
      this.b = Math.floor(b);
    },
  },
};
</script>

<style lang="scss" scoped>
.colorselector {
  -webkit-touch-callout: none;
  user-select: none;
  width: 100%;
  height: 100%;
}

.controls {
  position: relative;
  width: 100%;
  height: 100%;
}

.hex-input {
  width: 100%;
}

.marker {
  position: absolute;
  transform: translate(-0.5rem, -0.5rem);
  width: 1rem;
  height: 1rem;
  background-color: transparent;
  border-radius: 50%;
  border: 2px solid white;
  box-sizing: border-box;
  pointer-events: none;
}

.marker-width {
  position: absolute;
  transform: translateY(-0.05rem);
  width: 100%;
  height: 0.1rem;
  background-color: black;
  pointer-events: none;
}

.marker-height {
  position: absolute;
  transform: translateY(-0.05rem);
  width: 0.1rem;
  height: 100%;
  border-radius: 0.1rem;
  background-color: black;
  border: 1px solid white;
  pointer-events: none;
}

.color-selector {
  width: 100%;
  height: calc(100% - 3rem);
  font-size: 0;
}

.padder {
  height: 10%;
}

.colorselector-sat-light {
  display: inline-block;
  position: relative;
  top: 0;
  width: 100%;
  height: 50%;
  background-image: url('data:image/png;base64,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');
  cursor: crosshair;
  background-size: 100% 100%;
}

.colorselector-rgb {
  cursor: ew-resize;
  position: relative;
  display: block;
  width: 100%;
  height: 10%;
  background: linear-gradient(
    to right,
    #f00 0%,
    #ff0 17%,
    #0f0 33%,
    #0ff 50%,
    #00f 67%,
    #f0f 83%,
    #f00 100%
  );
}

.colorselector-a {
  cursor: ew-resize;
  position: relative;
  width: 100%;
  height: 10%;
  background-image:
    linear-gradient(
      45deg,
      black 25%,
      transparent 25%,
      transparent 75%,
      black 75%,
      black
    ),
    linear-gradient(45deg, black 25%, white 25%, white 75%, black 75%, black);
  background-size: 20px 20px;
  background-position:
    0 0,
    30px 30px;
}

.colorselector-output {
  margin: 1rem;
}
</style>
